/**
 * TYPES
 */
import {_aggregates} from 'src/aggregates/index.d';
import {_names} from 'src/aggregates/tags/commands.d';
import {ITagsCreate} from 'src/aggregates/tags/commands.d';
import {ITagsLoad} from 'src/aggregates/tags/commands.d';
import {ITagsErrorReset} from 'src/aggregates/tags/commands.d';
import {ITagsUpdate} from 'src/aggregates/tags/commands.d';
import {IUpdateTagPatch} from 'src/aggregates/tags/mutations.d';


/**
 * CODE
 */

/**
 * I am a command creator for tag creation.
 *
 * :param name: tag name
 * :param color: tag color
 *
 * :returns: customer load command
 */
function create (name: string, color: string): ITagsCreate
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: _names.TAGS_CREATE,
        _target: null,
        color,
        name,
    };
}


/**
 * I am a command creator for tag load.
 *
 * :returns: tag load command
 */
function load (): ITagsLoad
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: _names.TAGS_LOAD,
        _target: null,
    };
}


/**
 * I am a command creator for tag reset error.
 *
 * :returns: tag reset error command
 */
function resetError (): ITagsErrorReset
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: _names.TAGS_ERROR_RESET,
        _target: null,
    };
}


/**
 * I am a command creator for tag update.
 *
 * :param company: user company id
 *
 * :returns: tag update command
 */
function update (
    id: number,
    tag: IUpdateTagPatch,
    color: string,
): ITagsUpdate
{
    return {
        _aggregate: _aggregates.TAGS,
        _name: _names.TAGS_UPDATE,
        _target: id,
        color,
        tag,
    };
}


/**
 * EXPORTS
 */
export {
    create,
    load,
    resetError,
    update,
};
